import { render } from "./Nav2.vue?vue&type=template&id=52250dc6&scoped=true"
import script from "./Nav2.vue?vue&type=script&lang=js"
export * from "./Nav2.vue?vue&type=script&lang=js"

import "./Nav2.vue?vue&type=style&index=0&id=52250dc6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52250dc6"]])

export default __exports__